import { WEEKDAY_MAP } from "@/consts";
import type { RruleDaysState } from "@/types";
import { type ByWeekday } from "rrule";

export default (cadence: number, days: RruleDaysState) => {
  if (cadence === 7) {
    const items: ByWeekday[] = [];

    Object.keys(days).forEach((day, index) => {
      if (days[index] && WEEKDAY_MAP[index]) {
        items.push(WEEKDAY_MAP[index]);
      }
    });

    if (items.length) {
      return items;
    }
  }

  return undefined;
};
